/**
 * 用户默认头像
 */
export const DEFAULT_AVATAR =
  'https://img.meituan.net/portalweb/609c8cf7b7f8bc1198a24db654a6ddb19487.png';

/**
 * 小助手默认头像
 */
export const DEFAULT_HELPER_AVATAR =
  'https://p0.meituan.net/portalweb/2efd25a784ead88e46b4f266e726ef5611147.png';
